(function () {
  function getMoneyFormat() {
    var root = document.querySelector('[data-cs-accessory-recs]');
    return (root && root.getAttribute('data-money-format')) || '${{amount}}';
  }

  function formatMoney(cents) {
    var format = getMoneyFormat();
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount).replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function fitAccessoryRecSelectWidth(selectEl) {
    if (!selectEl || !selectEl.options.length) return;

    var card = selectEl.closest('.cs-accessory-rec__card');
    var label = selectEl.closest('label.cs-accessory-rec__variant');
    var body = selectEl.closest('.cs-accessory-rec__body');
    if (!card || !label || !body) return;

    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (isMobile) {
      var cardStyle = window.getComputedStyle(card);
      var padX = parseFloat(cardStyle.paddingLeft) + parseFloat(cardStyle.paddingRight);
      var gap = parseFloat(cardStyle.columnGap || cardStyle.gap) || 10;
      var media = card.querySelector('.cs-accessory-rec__media');
      var form = card.querySelector('.cs-accessory-rec__form');
      var mediaW = media ? media.getBoundingClientRect().width : 0;
      var formW = form ? form.getBoundingClientRect().width : 0;
      var maxLabelWidth = card.clientWidth - padX - mediaW - formW - gap * 2;

      if (!Number.isFinite(maxLabelWidth) || maxLabelWidth < 0) {
        maxLabelWidth = body.clientWidth;
      }

      label.style.maxWidth = Math.max(0, maxLabelWidth) + 'px';
      label.style.width = '100%';
      selectEl.style.width = '100%';
      selectEl.style.maxWidth = '100%';
      return;
    }

    label.style.maxWidth = '';
    label.style.width = '';

    var measure = document.createElement('span');
    measure.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;';
    measure.style.font = window.getComputedStyle(selectEl).font;
    document.body.appendChild(measure);

    var longestTextWidth = 0;
    for (var i = 0; i < selectEl.options.length; i++) {
      measure.textContent = selectEl.options[i].textContent.trim();
      longestTextWidth = Math.max(longestTextWidth, measure.offsetWidth);
    }
    document.body.removeChild(measure);

    var chevronGap = 2;
    var bodyWidth = body.clientWidth;
    var selectWidth = longestTextWidth + chevronGap;
    if (bodyWidth > 0) {
      selectWidth = Math.min(selectWidth, bodyWidth);
    }

    selectEl.style.maxWidth = bodyWidth > 0 ? bodyWidth + 'px' : '';
    selectEl.style.width = Math.max(selectWidth, 48) + 'px';
  }

  function openAccessoryRecSelect(select) {
    if (!select) return;
    try {
      if (typeof select.showPicker === 'function') {
        select.showPicker();
        return;
      }
    } catch (err) {}
    select.focus({ preventScroll: true });
    select.click();
  }

  function initAccessoryRecVariantPickers() {
    document.querySelectorAll('.cs-accessory-rec__variant-chevron').forEach(function (chevron) {
      chevron.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var label = chevron.closest('label.cs-accessory-rec__variant');
        openAccessoryRecSelect(label && label.querySelector('select'));
      });
      chevron.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    document.querySelectorAll('label.cs-accessory-rec__variant').forEach(function (label) {
      label.addEventListener('click', function (e) {
        if (e.target.tagName === 'SELECT') return;
        if (e.target.classList.contains('cs-accessory-rec__variant-chevron')) return;
        e.preventDefault();
        openAccessoryRecSelect(label.querySelector('select'));
      });
    });
  }

  function updateAccessoryRecCard(selectEl) {
    var card = selectEl.closest('.cs-accessory-rec__card');
    if (!card) return;

    var option = selectEl.options[selectEl.selectedIndex];
    var variantId = selectEl.value;
    var price = option.getAttribute('data-price');
    var compareAt = option.getAttribute('data-compare-at');
    var idInput = card.querySelector('[data-accessory-variant-id]');
    var addBtn = card.querySelector('[data-cs-accessory-add-btn]');

    if (idInput) idInput.value = variantId;

    var priceWrap = card.querySelector('[data-cs-accessory-rec-price] .cs-accessory-rec__price-line');
    if (priceWrap && price) {
      var html = '<ins><span class="cs-accessory-rec__amount">' + formatMoney(parseInt(price, 10)) + '</span></ins>';
      if (compareAt && parseInt(compareAt, 10) > parseInt(price, 10)) {
        html += '<del><span class="cs-accessory-rec__amount">' + formatMoney(parseInt(compareAt, 10)) + '</span></del>';
      }
      priceWrap.innerHTML = html;
    }

    if (addBtn) {
      if (option.disabled) {
        addBtn.setAttribute('disabled', 'disabled');
      } else {
        addBtn.removeAttribute('disabled');
      }
    }

    var imageUrl = option.getAttribute('data-image');
    var imageEl = card.querySelector('[data-cs-accessory-rec-image]');
    if (imageEl && imageUrl) {
      imageEl.src = imageUrl;
      imageEl.removeAttribute('srcset');
      var imageAlt = option.getAttribute('data-image-alt');
      if (imageAlt) {
        imageEl.alt = imageAlt;
      }
    }

    fitAccessoryRecSelectWidth(selectEl);
  }

  function refreshCartUiAfterAdd(addBtn) {
    var minicart = document.querySelector('mini-cart');

    if (minicart && typeof minicart.open === 'function') {
      minicart.open(addBtn);
      return;
    }

    try {
      document.dispatchEvent(new CustomEvent('open-mini-cart', { detail: { opener: addBtn } }));
    } catch (err) {}
  }

  function handleAccessoryRecAddClick(e) {
    e.preventDefault();
    e.stopPropagation();

    var addBtn = e.currentTarget;
    if (addBtn.disabled) return;

    var card = addBtn.closest('.cs-accessory-rec__card');
    var idInput = card && card.querySelector('[data-accessory-variant-id]');
    var variantId = idInput && idInput.value;
    if (!variantId) return;

    addBtn.setAttribute('disabled', 'disabled');
    addBtn.classList.add('is-loading');

    var minicart = document.querySelector('mini-cart');
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (minicart && typeof minicart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        minicart.getSectionsToRender().map(function (section) {
          return section.section;
        }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
    }

    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          window.alert(response.description || response.message || 'Could not add to cart');
          if (minicart && typeof minicart.updateSectionContents === 'function') {
            minicart.updateSectionContents();
          }
          return;
        }

        if (minicart && typeof minicart.renderContents === 'function' && response.sections) {
          minicart.renderContents(response);
          refreshCartUiAfterAdd(addBtn);
        } else if (minicart && typeof minicart.updateSectionContents === 'function') {
          minicart.updateSectionContents().then(function () {
            refreshCartUiAfterAdd(addBtn);
          });
        } else {
          refreshCartUiAfterAdd(addBtn);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartItemAdd, {
            source: 'AccessoryRecommendations',
            items: [response]
          });
        }
      })
      .catch(function () {
        window.alert('Could not add to cart');
      })
      .finally(function () {
        addBtn.classList.remove('is-loading');
        var selectEl = card.querySelector('.cs-accessory-rec__variant-select');
        var optionDisabled =
          selectEl &&
          selectEl.options[selectEl.selectedIndex] &&
          selectEl.options[selectEl.selectedIndex].disabled;
        if (!optionDisabled) {
          addBtn.removeAttribute('disabled');
        }
      });
  }

  function syncAllAccessoryRecCards() {
    document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(function (selectEl) {
      updateAccessoryRecCard(selectEl);
    });
  }

  function initAccessoryRecommendations() {
    var root = document.querySelector('[data-cs-accessory-recs]');
    if (!root) return;

    syncAllAccessoryRecCards();

    if (root.getAttribute('data-cs-bound') === '1') return;
    root.setAttribute('data-cs-bound', '1');

    document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(function (selectEl) {
      selectEl.addEventListener('change', function () {
        updateAccessoryRecCard(selectEl);
      });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('.cs-accessory-rec__variant-select').forEach(fitAccessoryRecSelectWidth);
    });

    document.querySelectorAll('[data-cs-accessory-add-btn]').forEach(function (btn) {
      btn.addEventListener('click', handleAccessoryRecAddClick);
    });

    initAccessoryRecVariantPickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccessoryRecommendations);
  } else {
    initAccessoryRecommendations();
  }

  window.addEventListener('pageshow', function (e) {
    syncAllAccessoryRecCards();
    window.setTimeout(syncAllAccessoryRecCards, 0);
    if (e.persisted) {
      window.setTimeout(syncAllAccessoryRecCards, 200);
    }
  });
})();
